import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

class HistoricsReportTable extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    count: PropTypes.number.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    company: PropTypes.any,
    subcompany: PropTypes.any,
    permissions: PropTypes.any,
  };

  render = () => {
    const { company, subcompany, permissions, t, children } = this.props;
    const headers = [
      {
        variable: 'key',
        text: t('employees.fields.key') + ': ',
        type: 'h3',
      },
      { variable: 'name', text: t('employees.fields.name') + ': ' },
      { variable: 'lastname', text: t('employees.fields.lastname') + ': ' },
      { variable: 'position', text: t('employees.fields.position') + ': ' },
      { variable: 'total', text: t('employees.fields.numberAssignedAssets') + ': ' },
    ];

    const config = {
      actions: t('common.actions'), //Texto de seccion de acciones
      edit: t('common.edit'), //Texto de boton editar
      editPermission: 'acl.assets.update.NoTiene',
      togglePermission: 'acl.assets.toggle.NoTiene',
      editUrl: 'assets', //Url para editar empleado
      propsName: 'record', //de donde se obtienen los props
      company: company,
      subcompany: subcompany,
      gPDF: true,
    };

    const dataCard = {
      rows: children,
      headers: headers,
      config: config,
      permissions: permissions,
    };

    return (
      <Common.List dataCard={dataCard}>
        <thead>
          <tr>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.status')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.createdAt')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.reviewDate')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.createdBy')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.reviewedBy')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.key"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.key')}
            </Common.ThSortable>

            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.name"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.name')}
            </Common.ThSortable>

            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.location"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.location')}
            </Common.ThSortable>

            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.account"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.account')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.sub_account"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.sub_account')}
            </Common.ThSortable>
            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.costCenter"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.costCenter')}
            </Common.ThSortable>

            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.lastname"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.asigned')}
            </Common.ThSortable>

            <Common.ThSortable
              className="text-center align-middle"
              orderBy={this.props.orderBy}
              order={this.props.order}
              field="_id.position"
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.t('reports.historics.fields.asigned_status')}
            </Common.ThSortable>

            {/* <th className="text-center"># Activos asignados</th> */}

            <th className="text-center">{this.props.t('common.actions')}</th>
          </tr>
        </thead>

        <tbody>
          {this.props.count === 0 && <Common.EmptyTable colSpan={20} />}
          {this.props.children}
        </tbody>
      </Common.List>
    );
  };
}

export default translate()(HistoricsReportTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/historics/HistoricsReportTable.js